module.exports = __webpack_public_path__ + "img/otsuzuki.463fc207.jpg";